export const addDot = (text: string | undefined): string => {
  if (!text) return '';
  let result = text;

  if (text.trim().split('').pop() !== '.') {
    result = text + '.';
  }
  return result;
};
